module.exports = __webpack_public_path__ + "static/media/649.2e04847a.webp";